import React, { createContext, useContext, useState, useEffect } from 'react';

const AppearanceContext = createContext();

export function AppearanceProvider({ children }) {
  const [compactView, setCompactView] = useState(() => {
    const saved = localStorage.getItem('compactView');
    return saved ? JSON.parse(saved) : false;
  });

  const [reducedMotion, setReducedMotion] = useState(() => {
    const saved = localStorage.getItem('reducedMotion');
    return saved ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever settings change
  useEffect(() => {
    localStorage.setItem('compactView', JSON.stringify(compactView));
  }, [compactView]);

  useEffect(() => {
    localStorage.setItem('reducedMotion', JSON.stringify(reducedMotion));
  }, [reducedMotion]);

  // Apply CSS custom properties based on settings
  useEffect(() => {
    const root = document.documentElement;
    
    if (compactView) {
      root.style.setProperty('--template-spacing-factor', '0.75');
      root.style.setProperty('--template-card-padding', '12px');
    } else {
      root.style.setProperty('--template-spacing-factor', '1');
      root.style.setProperty('--template-card-padding', '16px');
    }

    if (reducedMotion) {
      root.style.setProperty('--template-transition-duration', '0ms');
    } else {
      root.style.setProperty('--template-transition-duration', '200ms');
    }
  }, [compactView, reducedMotion]);

  const value = {
    compactView,
    setCompactView,
    reducedMotion,
    setReducedMotion,
  };

  return (
    <AppearanceContext.Provider value={value}>
      {children}
    </AppearanceContext.Provider>
  );
}

export function useAppearance() {
  const context = useContext(AppearanceContext);
  if (!context) {
    throw new Error('useAppearance must be used within an AppearanceProvider');
  }
  return context;
}